export default "__VITE_ASSET__CsJpsP7F__"